import axios from 'axios';

import { ERROR_GENERAL } from '../../../../shared/constants';
import { headersWithCSRF } from '../../../../shared/utils/csrf';
import { CONVERSATION } from '../../../shared/api';

export const fetchConversation = async (taskId) => {
  try {
    const url = `${CONVERSATION.replace(':taskId', taskId)}?include=messages,messages.sender`;

    const response = await axios.get(url, {
      headers: headersWithCSRF,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || ERROR_GENERAL);
  }
};
